// extracted by mini-css-extract-plugin
module.exports = {"mobileMaxWidth":"1024px","desktopMinWidth":"1025px"};